import './ChatBot.css'
import Logo from '../../assets/img/logo-fixauto.svg'

export const ChatBotPage = () => {

  const onClick = () => {
    window.open('https://t.me/fix_auto_md_bot', '_blank'); // Deschide într-un tab nou
  }

  return (
    <div style={{marginTop:'150px'}}>
        <div className="max-width">
          <div className="content">
            <div className="card main-card">
              <div>
                <img
                  src={Logo}
                  alt="Logo"
                  style={{ width: '150px', height: '50px' }} // sau folosește variabile
                />
              </div>

              <div className="message-container">
                <h1 className="title">
                  Pentru a continua, alege messenger-ul deja instalat
                </h1>
              </div>

              <div className="messenger-buttons">
                <button className="messenger-button telegram" onClick={onClick}>
                  <div className="messenger-icon telegram-icon"></div>
                  Telegram
                </button>

                <button className="messenger-button viber" disabled>
                  <div className="messenger-icon viber-icon"></div>
                  Viber
                </button>

                <button className="messenger-button whatsapp" disabled>
                  <div className="messenger-icon whatsapp-icon"></div>
                  WhatsApp
                </button>
              </div>
            </div>

            <div className="card info-card">
              <p className="info-text">
                Contacte autoservice Chișinău, Moldova, reparații auto, reparare suspensie, turbină, casetă de direcție, amortizoare, chei auto
              </p>
            </div>
          </div>
      </div>
    </div>
  );

}